import React from 'react';
import '../App.css';
import '../style.css';
import { Link } from 'react-router-dom';
import {useState} from 'react';
import { Thumbnail } from './WorkThumbnail';
import { useLanguage } from '../contexts/LanguageContext';


export function Content (props: {
    thumbnail: string;
    projectTitle: string;
    projectDescription : string;
    projectSubtitle : string;
    period : string;
    projectPage : string;
    badge? : string;
    // 수동 번역(한국어) 전달용 선택적 프로퍼티들
    projectTitleKo?: string;
    projectDescriptionKo?: string;
    projectSubtitleKo?: string;
    badgeKo?: string;
}) {
    const [isHovering, setIsHovering] = useState(false);
    const { language } = useLanguage();

    // 언어에 따라 표시할 텍스트 결정
    const displayTitle = language === 'ko' ? (props.projectTitleKo ?? props.projectTitle) : props.projectTitle;
    const displayDescription = language === 'ko' ? (props.projectDescriptionKo ?? props.projectDescription) : props.projectDescription;
    const displaySubtitle = language === 'ko' ? (props.projectSubtitleKo ?? props.projectSubtitle) : props.projectSubtitle;
    const displayBadge = language === 'ko' ? (props.badgeKo ?? props.badge) : props.badge;

  return (
    <div className='projectContentsAll' onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
        {displayBadge && <div className = 'projectNewBadge'><span className="projectNewBadgeText">{displayBadge}</span></div>}
        <Link to={`/${props.projectPage}`} className='project' style={{textDecoration: 'none'}} >
        <Thumbnail thumbnail={props.thumbnail} isHovered={isHovering}/>
        <div className='projectContents'>
            <div className='projectSubtitle'>
                {displaySubtitle}
            </div>
            <div style={{display : "flex", flexDirection : "column",gap:"10px"}}>
                <div className="projectTitle">
                    {displayTitle}
                </div>
                <div className='projectDescription'>
                    {displayDescription}
                </div>
            </div>
            <div className='projectPeriod'>{props.period}</div>
        </div>
        </Link>
    </div>
  
  );
}

export default Content;